module.exports = __webpack_public_path__ + "static/s1-bottled-d-110b609670d652ed2ac9f1a221bae38d.jpg";